import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MentionsRequest, type UserMention } from 'src/requests/mentions';

export const useMentionsMutation = () => {
  const queryClient = useQueryClient();

  const { mutate: readMention, isLoading: isReading } = useMutation({
    mutationFn: MentionsRequest.readMention,
    onSuccess(data) {
      queryClient.setQueryData<UserMention[]>(
        ['mentions'],
        (currentData) =>
          currentData &&
          currentData.map((c) =>
            c.result._id === data.mentionRefId
              ? { ...c, readed: true, mention: data }
              : c,
          ),
      );
    },
  });

  const { mutate: removeMention, isLoading: isRemoving } = useMutation({
    mutationFn: MentionsRequest.removeMention,
    onSuccess(data) {
      queryClient.setQueryData<UserMention[]>(
        ['mentions'],
        (currentData) =>
          currentData &&
          currentData.filter((c) => c.result._id !== data.mentionRefId),
      );
    },
  });

  return {
    isReading,
    isRemoving,
    readMention,
    removeMention,
  };
};
